<template>
    <div>
        <v-card class="ma-3 pa-5" v-if="activeProbe">
            <v-row justify="space-between" class="pa-3">
                <h3>{{ activeProbe.name }}</h3>
                <v-spacer/>

                <v-btn
                    @click="handleMergeStationClick"
                    color="primary"
                    class="mr-2"
                    small
                    v-if="user.role === 'super_admin'"
                >
                    <v-icon
                        left
                        dark
                    >
                        mdi-merge
                    </v-icon>
                    Merge station
                </v-btn
                >
                <v-btn
                    @click="handleOpenRegionModal"
                    color="primary"
                    class="mr-2"
                    small
                    v-if="user.role === 'super_admin' || user.role === 'admin'"
                >
                    <v-icon
                        left
                        dark
                    >
                        mdi-earth
                    </v-icon>
                    Add region
                </v-btn
                >
                <v-btn @click="handleFetchPercoDataClick" color="primary" class="mr-2" small>
                    <v-icon
                        left
                        dark
                    >
                        mdi-generator-portable
                    </v-icon>
                    Fetch perco data
                </v-btn>
                <v-btn @click="navigateToProbeMeasurements" color="primary" small>
                    <v-icon
                        left
                        dark
                    >
                        mdi-tape-measure
                    </v-icon>
                    Measurements
                </v-btn>
            </v-row>
            <v-divider class="my-3"/>

            <v-text-field label="Alias" readonly :value="activeProbe.alias"/>
            <v-text-field label="Long Alias" readonly :value="activeProbe.long_alias"/>
            <v-select
                item-value="name"
                item-text="name"
                :items="soilTypes"
                label="Soil type"
                v-model="activeProbe.soil_type"
            />
            <v-select
                item-value="value"
                item-text="name"
                :items="stationStates"
                label="PT Condition"
                v-model="activeProbe.latest_state"
            />
            <v-text-field label="Country" readonly disabled :value="activeProbe.latest_country"/>


            <v-switch v-model="activeProbe.is_active" label="Active" color="success"></v-switch>
            <v-switch
                v-if="['super_admin', 'admin'].includes(user.role)"
                v-model="activeProbe.use_for_map_layers"
                label="Use for map layers"
                color="success"
                @change="handleUseForMapLayersCheckboxToggle"
            ></v-switch>
            <h5>Created at {{ activeProbe.created_at | formatDate }}</h5>
            <v-btn @click="updateProbe" class="mt-3" color="primary">Save</v-btn>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'StationViewInformation',
    data() {
        return {
            stationStates: [
                {name: 'Working', value: 'working'},
                {name: 'In Stock', value: 'in_stock'},
                {name: 'To Collect', value: 'to_collect'},
                {name: 'Maintenance', value: 'maintenance'},
                {name: 'Closed Replaced', value: 'closed_replaced'},
                {name: 'Closed Fully', value: 'closed_fully'},
                {name: 'Billable trial', value: 'billable_trial'},
                {name: 'Free trial', value: 'free_trial'},
                {name: 'Repair', value: 'repair'},
                {name: 'Customer stock', value: 'customer_stock'},
            ],
        };
    },
    computed: {
        ...mapState('probe', ['activeProbe']),
        ...mapState('soil', ['soilTypes']),
        ...mapState('auth', ['user']),
    },
    async mounted() {
        await this.fetchSoilTypesList();
    },
    methods: {
        ...mapActions('probe', ['updateProbe', 'toggleProbeUseForMap']),
        ...mapActions('soil', ['fetchSoilTypesList']),
        ...mapMutations('probe', ['setPercoModal', 'setRegionModal', 'setMergeStationModal']),
        navigateToProbeMeasurements() {
            this.$router.push({name: 'station-measurement', params: {id: this.activeProbe.id}});
        },
        async handleFetchPercoDataClick() {
            await this.setPercoModal(true);
        },
        async handleOpenRegionModal() {
            await this.setRegionModal(true);
        },
        async handleUseForMapLayersCheckboxToggle() {
            await this.toggleProbeUseForMap({
                itemId: this.activeProbe.id,
                value: this.activeProbe.use_for_map_layers,
            });
        },

        async handleMergeStationClick() {
            await this.setMergeStationModal(true);
        }
    },
};
</script>

<style scoped></style>
